import {
    COURSE_TYPES_CHOICES,
    PROD_TYPES_CHOICES,
} from "../../components/Enumerators";

/* wyświetla typ kursu */
// const ProdType=(props: {inStore?: IInStore, prodDef?:IProdDef}) => {
const ProdType = (props: {
    prodType?: PROD_TYPES_CHOICES;
    courseType?: COURSE_TYPES_CHOICES;
    className?: string;
}) => {
    let prodTypeName = undefined;

    if (props.prodType === PROD_TYPES_CHOICES.PROD_TYPE_COURSE) {
        if (props.courseType === COURSE_TYPES_CHOICES.COURSE_TYPE_WEBINAR) {
            prodTypeName = "Webinar";
        } else if (
            props.courseType === COURSE_TYPES_CHOICES.COURSE_TYPE_STATIONARY
        ) {
            prodTypeName = "Szkolenie stacjonarne";
        } else if (
            props.courseType === COURSE_TYPES_CHOICES.COURSE_TYPE_ECOURSE
        ) {
            prodTypeName = "E-kurs";
        }
    }

    return (
        <>
            {prodTypeName && (
                <div className={props.className}>{prodTypeName}</div>
            )}
        </>
    );
};

export default ProdType;
